import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { pdfDownloadEvent } from 'teacher-ui-client/modifiers/pdf-download-event'
import truncate from 'teacher-ui-client/helpers/truncate'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Args {
  fileUrl: string
  description: string
  title: string
  coverUrl: string
}

interface Signature {
  Args: Args
  Element: HTMLAnchorElement
}
export const ResearchReportTile: TOC<Signature> = <template>
  <a
    href={{@fileUrl}}
    target="_blank"
    rel="noopener noreferrer"
    class="group relative w-96 rounded-b-md border-2 p-4 shadow-xs hover:shadow-lg focus:shadow-lg"
    aria-label={{t "download"}}
    data-test-research-report-tile
    {{pdfDownloadEvent category="Research Reports PDF" label=@title}}
    ...attributes
  >
    <img
      src="{{@coverUrl}}?h=250"
      class="border-dusty-black-100 float-left mr-4 rounded-md border shadow-xs"
      alt="{{@title}}"
      width="100"
      height="140"
    />
    <div>
      <h4 class="mb-3 text-left">
        {{@title}}
      </h4>
      <p class="mb-3">
        {{truncate @description characterLimit=100}}
      </p>
    </div>
    <PhosphorIcon
      @icon="phosphor-download-fill"
      class="invisible absolute right-0 bottom-0 m-4 h-8 w-8 group-hover:visible group-focus:visible"
    />
  </a>
</template>

export default ResearchReportTile
